import React from 'react';

interface Props {
  rules: {
    length: boolean;
    uppercase: boolean;
    number: boolean;
    special: boolean;
    match?: boolean;
  };
}

const PasswordRules: React.FC<Props> = ({ rules }) => {
  const { length, uppercase, number, special, match } = rules;
  return (
    <div
      className="p-6 rounded-2xl"
      style={{
        background: 'rgba(13, 24, 48, 0.6)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <h3 className="text-white text-lg font-semibold mb-4">Password Requirements:</h3>
      <div className="flex flex-col gap-3 text-white/80 text-sm">
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${length ? 'border-[#17c480] bg-[#17c480]' : 'border-white/40'}`}>
            {length && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>At least 8 characters</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${uppercase ? 'border-[#17c480] bg-[#17c480]' : 'border-white/40'}`}>
            {uppercase && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>One uppercase letter (A-Z)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${number ? 'border-[#17c480] bg-[#17c480]' : 'border-white/40'}`}>
            {number && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>One number (0-9)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${special ? 'border-[#17c480] bg-[#17c480]' : 'border-white/40'}`}>
            {special && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>One special character (!@#$%^&*)</span>
        </div>
        {typeof match !== 'undefined' && (
          <div className="flex items-center gap-2">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${match ? 'border-[#17c480] bg-[#17c480]' : 'border-white/40'}`}>
              {match && (
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <span>Passwords match</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordRules;
